import styled from '@eduzz/houston-styles';

export const ImgContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 1.5rem;

  img {
    max-width: 2.5rem;
    max-width: 2.5rem;
  }

  span {
    font-weight: 400;
    font-size: 1.5rem;
    color: #242424;
    margin-left: 0.5rem;
  }
`;
